import React, { memo } from 'react';
import { format } from 'date-fns';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES, DATE_TIME_FORMAT } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingDisclosure({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const {
    currency,
    asOfDate1,
    asOfDate2,
    asOfDate1Custom,
    asOfDate2Custom,
    includedFields,
  } = reportSnapshot;
  
  const reportPossibleField = includedFields[0]?.reportPossibleField;
  const wasRanWithAllocations = reportPossibleField?.isAllocation || reportPossibleField?.isDimension;
  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="calendar" />
        <GStyled.Text>Start Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {asOfDate1Custom
            ? `${asOfDate1Custom.month}/${asOfDate1Custom.year}`
            : format(asOfDate1, DATE_TIME_FORMAT.MONTH_YEAR)}
        </GStyled.Text>
        <GStyled.Text>End Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {asOfDate2Custom
            ? `${asOfDate2Custom.month}/${asOfDate2Custom.year}`
            : format(asOfDate2, DATE_TIME_FORMAT.MONTH_YEAR)}
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      {/* Hide View By if disclosure report has fields and isAllocation => meaning it was ran with allocations */}
      {/* COR-19376 TODO: API To Return Allocations for Complete Disclosure Snapshot */}
      {!wasRanWithAllocations && (
        <Styled.ReportSettingItem>
          <Icon name="gear" />
          <GStyled.Text>View By</GStyled.Text>
          <GStyled.Text fontWeight="medium">Total Org</GStyled.Text>
        </Styled.ReportSettingItem>
      )}
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingDisclosure);
